import { money } from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";
import { Download, Upload, Send, Banknote } from "lucide-react";

// Wallet withdrawal (Interac e-Transfer) queue. State/handlers come from AdminDashboard.
export const WithdrawalsTab = ({
  withdrawals, wdFilter, setWdFilter, exportCsv, uploadManualStatus,
  sendPayoutDigest, sendingDigest, releaseWithdrawal,
}) => (
  <>
    <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
      <div className="inline-flex items-center gap-1 rounded-full border border-black/10 bg-white p-1" data-testid="wd-filter">
        {["all", "manual", "auto"].map((f) => (
          <button key={f} data-testid={`wd-filter-${f}`} onClick={() => setWdFilter(f)}
            className={`rounded-full px-3 py-1 text-xs font-medium capitalize transition-colors ${wdFilter === f ? "bg-foreground text-background" : "text-foreground/70 hover:bg-secondary"}`}>
            {f === "manual" ? "Manual (<$50)" : f === "auto" ? "Auto (≥$50)" : "All"}
          </button>
        ))}
      </div>
      <div className="flex items-center gap-1">
        <Button variant="ghost" size="sm" data-testid="download-manual-payments-btn" onClick={() => exportCsv("/admin/payments/manual/export", "bogoshare_manual_payments.csv")} className="text-muted-foreground">
          <Download className="mr-1 h-4 w-4" /> Manual payments CSV
        </Button>
        <input type="file" accept=".csv" id="manual-status-input" data-testid="manual-status-input" onChange={uploadManualStatus} className="hidden" />
        <Button variant="ghost" size="sm" data-testid="upload-manual-status-btn" onClick={() => document.getElementById("manual-status-input").click()} className="text-muted-foreground">
          <Upload className="mr-1 h-4 w-4" /> Upload status
        </Button>
        <Button variant="ghost" size="sm" data-testid="send-digest-btn" onClick={sendPayoutDigest} disabled={sendingDigest} className="text-muted-foreground">
          <Send className="mr-1 h-4 w-4" /> {sendingDigest ? "Sending…" : "Email digest now"}
        </Button>
        <Button variant="ghost" size="sm" data-testid="export-withdrawals-btn" onClick={() => exportCsv("/admin/withdrawals/export", "bogoshare_withdrawals.csv")} className="text-muted-foreground">
          <Download className="mr-1 h-4 w-4" /> All
        </Button>
      </div>
    </div>
    {(() => { const rows = withdrawals.filter((w) => wdFilter === "all" || w.routing === wdFilter); return rows.length === 0 ? (
      <p className="text-muted-foreground" data-testid="wd-empty">No {wdFilter === "all" ? "" : wdFilter + " "}withdrawals.</p>
    ) : (
      <div className="space-y-3">
        {rows.map((w) => (
          <div key={w.txn_id} data-testid={`withdrawal-${w.txn_id}`} className="flex items-center gap-4 rounded-xl border border-black/10 bg-white p-4">
            <div className={`flex h-10 w-10 items-center justify-center rounded-lg ${w.status === "pending" ? "bg-amber-100 text-amber-700" : "bg-green-100 text-green-700"}`}>
              <Banknote className="h-5 w-5" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-heading text-lg" style={{ fontWeight: 600 }}>{money(Math.abs(w.amount))}</p>
              <p className="text-sm text-muted-foreground truncate">
                {w.user_name || w.user_email} → {w.destination || w.payout_email || "—"}
              </p>
              <div className="mt-1 flex flex-wrap items-center gap-2 text-xs">
                <span data-testid={`withdrawal-routing-${w.txn_id}`} className={`inline-flex items-center rounded-full px-2 py-0.5 font-semibold ${w.routing === "manual" ? "bg-purple-100 text-purple-700" : "bg-sky-100 text-sky-700"}`}>
                  {w.routing === "manual" ? "Manual" : "Auto"}
                </span>
                <span data-testid={`withdrawal-method-${w.txn_id}`} className="inline-flex items-center rounded-full bg-secondary px-2 py-0.5 font-semibold text-foreground/70">
                  Interac e-Transfer
                </span>
                <span data-testid={`withdrawal-status-${w.txn_id}`} className={`inline-flex items-center rounded-full px-2 py-0.5 font-semibold ${w.status === "pending" ? "bg-amber-100 text-amber-800" : "bg-green-100 text-green-800"}`}>
                  {w.status}
                </span>
                {w.reference && <span className="font-mono-code text-muted-foreground">{w.reference}</span>}
                <span className="text-muted-foreground">{new Date(w.created_at).toLocaleString()}</span>
              </div>
            </div>
            {w.status === "pending" && (
              <Button size="sm" data-testid={`release-withdrawal-${w.txn_id}`} onClick={() => releaseWithdrawal(w.txn_id)} className="rounded-full shrink-0">
                <Send className="mr-1 h-3.5 w-3.5" /> Release
              </Button>
            )}
          </div>
        ))}
      </div>
    ); })()}
  </>
);

export default WithdrawalsTab;
